import classNames from 'classnames';
import React from 'react';
import { ChevronDownLarge, ChevronLeftLarge, ChevronRightLarge, ChevronUpLarge } from 'wix-ui-icons-common';
import { useFocusedLayout } from '../../../../hooks/focused-layout';
import { IconButton } from '../../../commons/icon-button';
import { useSession } from '../../session-provider';
import { useVideoConfig } from '../../video-config-provider';
import { Tile } from '../tile';
import { ScreenShare } from '../tile/screen-share';
import s from './focused-layout.scss';
import { TileContainer } from './tile-container';
export const FocusedLayout = ({ width, height }) => {
    const { mobile, sidePanelOpened, recorder } = useVideoConfig();
    const { attendees, currentAttendeeId, sharingAttendeeId, focusedAttendeeId } = useSession();
    const filteredAttendees = recorder ? attendees.filter(attendee => attendee !== currentAttendeeId) : attendees;
    const { pagesCount, currentPage, visibleAttendeeIds, setCurrentPage } = useFocusedLayout(mobile, width, height, filteredAttendees, focusedAttendeeId);
    const landscape = window.innerWidth > window.innerHeight;
    const isFocused = (attendeeId) => !sharingAttendeeId && attendeeId === focusedAttendeeId;
    const isVisible = (attendeeId) => visibleAttendeeIds.includes(attendeeId);
    const setPreviousPage = () => (currentPage === 0 ? setCurrentPage(pagesCount - 1) : setCurrentPage(currentPage - 1));
    const setNextPage = () => (currentPage + 1 === pagesCount ? setCurrentPage(0) : setCurrentPage(currentPage + 1));
    const mobileScreenSharing = Boolean(sharingAttendeeId && mobile);
    const mobileScreenSharingPanelOpened = mobileScreenSharing && sidePanelOpened;
    const mobileScreenSharingLandscape = mobileScreenSharing && landscape;
    const mobileSidePanelOpen = Boolean(mobile && sidePanelOpened);
    const singleTile = filteredAttendees.length === 1 && !sharingAttendeeId;
    const showMainAttendee = !mobileScreenSharingPanelOpened && !mobileScreenSharingLandscape;
    const showAdditionalAttendees = !singleTile && !mobileScreenSharingPanelOpened && !mobileScreenSharingLandscape;
    const mainAttendee = showMainAttendee
        ? filteredAttendees.find(id => {
            const focused = isFocused(id);
            return singleTile ? focused || isVisible(id) : focused;
        })
        : null;
    const additionalAttendees = showAdditionalAttendees
        ? filteredAttendees.filter(id => !isFocused(id) && isVisible(id))
        : [];
    return (React.createElement("div", { className: classNames(s.container, {
            [s.mobile]: mobile,
            [s.desktop]: !mobile,
            [s.singleTile]: singleTile,
            [s.mobileScreenSharing]: mobileScreenSharing,
            [s.mobileScreenSharingPanelOpened]: mobileScreenSharingPanelOpened,
            [s.mobileSidePanelOpen]: mobileSidePanelOpen,
            [s.landscape]: landscape,
        }) },
        sharingAttendeeId && (React.createElement(TileContainer, { screenShare: true },
            React.createElement(ScreenShare, null))),
        mainAttendee && (React.createElement(AttendeeTile, { key: mainAttendee, attendeeId: mainAttendee, focused: isFocused(mainAttendee), singleTile: singleTile, sharing: sharingAttendeeId === mainAttendee })),
        showAdditionalAttendees && (React.createElement("div", { className: classNames(s.tilesContainer, { [s.mobile]: mobile }) }, additionalAttendees.map(attendeeId => (React.createElement(AttendeeTile, { key: attendeeId, attendeeId: attendeeId, focused: isFocused(attendeeId), singleTile: singleTile, sharing: sharingAttendeeId === attendeeId }))))),
        pagesCount > 1 && (React.createElement(React.Fragment, null,
            React.createElement(IconButton, { className: s.buttonPrevious, Icon: mobile ? ChevronLeftLarge : ChevronUpLarge, onClick: setPreviousPage }),
            React.createElement(IconButton, { className: s.buttonNext, Icon: mobile ? ChevronRightLarge : ChevronDownLarge, onClick: setNextPage })))));
};
const AttendeeTile = ({ focused, singleTile, attendeeId, sharing }) => (React.createElement(TileContainer, { focused: focused, singleTile: singleTile, sharing: sharing },
    React.createElement(Tile, { focused: focused, attendeeId: attendeeId })));
//# sourceMappingURL=focused-layout.js.map